import React, { useState } from 'react';

export default function CreateFromAvailabilityModal({ onClose, onCreate }) {
    const [startTime, setStartTime] = useState('09:00');
    const [endTime, setEndTime] = useState('17:00');
    const [maxShifts, setMaxShifts] = useState(20);

    const handleCreate = () => {
        // UI placeholder per user instructions
        alert('This is a UI preview. Backend logic will be added after manager approval.');
        onClose();
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={styles.header}>
                    <h2 style={styles.title}>Create shifts from availability</h2>
                    <p style={styles.subtitle}>Creates shifts on available days that do not already have an active shift. Conflicts will still be checked.</p>
                </div>
                
                <div style={styles.content}>
                    <div style={styles.inputGroup}>
                        <label style={styles.label}>Start time</label>
                        <input 
                            type="time" 
                            style={styles.input}
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                    </div>
                    
                    <div style={{ ...styles.inputGroup, marginTop: '20px' }}>
                        <label style={styles.label}>End time</label>
                        <input 
                            type="time" 
                            style={styles.input}
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                    </div>

                    <div style={{ marginTop: '20px' }}>
                        <select 
                            style={{ ...styles.input, width: 'auto' }}
                            value={maxShifts}
                            onChange={(e) => setMaxShifts(Number(e.target.value))}
                        >
                            <option value={5}>Create up to 5</option>
                            <option value={10}>Create up to 10</option>
                            <option value={20}>Create up to 20</option>
                            <option value={30}>Create up to 30</option>
                        </select>
                    </div>
                </div>

                <div style={styles.footer}>
                    <button onClick={onClose} style={styles.cancelBtn}>Cancel</button>
                    <button onClick={handleCreate} style={styles.createBtn}>Create</button>
                </div>
            </div>
        </div>
    );
}

const styles = {
    overlay: {
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
        justifyContent: 'center', alignItems: 'center', zIndex: 1000
    },
    modal: {
        backgroundColor: 'white', borderRadius: '12px', width: '90%', maxWidth: '450px',
        boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)', overflow: 'hidden'
    },
    header: {
        padding: '24px 24px 16px', borderBottom: '1px solid #e5e7eb'
    },
    title: {
        margin: 0, fontSize: '18px', color: '#111827', fontWeight: 'bold'
    },
    subtitle: {
        margin: '8px 0 0 0', fontSize: '13px', color: '#6b7280', lineHeight: 1.4
    },
    content: {
        padding: '24px'
    },
    inputGroup: {
        display: 'flex', flexDirection: 'column', position: 'relative'
    },
    label: {
        position: 'absolute', top: '-8px', left: '8px', backgroundColor: 'white', 
        padding: '0 4px', fontSize: '11px', color: '#6b7280'
    },
    input: {
        padding: '12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '14px', outline: 'none',
        width: '100%', boxSizing: 'border-box'
    },
    footer: {
        padding: '16px 24px', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: '12px'
    },
    cancelBtn: {
        padding: '8px 16px', border: 'none', background: 'none', color: '#3b82f6', fontWeight: '500', cursor: 'pointer'
    },
    createBtn: {
        padding: '8px 16px', backgroundColor: '#3b82f6', color: 'white', border: 'none', borderRadius: '6px', fontWeight: '500', cursor: 'pointer'
    }
};
